import { defineSlotRecipe as t } from "@pandacss/dev";
import { anatomy as r } from "../../node_modules/@ark-ui/anatomy/node_modules/@zag-js/switch/dist/index.mjs";
const a = t({
  className: "switch",
  slots: r.keys(),
  base: {
    root: {
      alignItems: "center",
      colorPalette: "accent",
      display: "flex",
      position: "relative"
    },
    control: {
      alignItems: "center",
      background: "bg-tertiary",
      borderRadius: "full",
      cursor: "pointer",
      display: "inline-flex",
      flexShrink: "0",
      transitionDuration: "normal",
      transitionProperty: "background",
      transitionTimingFunction: "default",
      _checked: {
        background: "bg-brand-primary"
      },
      _disabled: {
        cursor: "not-allowed",
        background: "bg-disabled"
      }
    },
    thumb: {
      background: "bg-primary",
      borderRadius: "full",
      boxShadow: "xs",
      transitionDuration: "normal",
      transitionProperty: "transform, background",
      transitionTimingFunction: "default",
      _checked: {
        transform: "translateX(100%)",
        background: { base: "fg-white", _dark: "bg-brand-primary" }
      },
      _disabled: {
        background: "fg-disabled_subtle"
      }
    }
  },
  defaultVariants: {
    size: "md"
  },
  variants: {
    size: {
      sm: {
        root: {
          gap: "2"
        },
        control: {
          width: "7",
          p: "0.5"
        },
        thumb: {
          width: "3",
          height: "3"
        }
      },
      md: {
        root: {
          gap: "3"
        },
        control: {
          width: "9",
          p: "0.5"
        },
        thumb: {
          width: "4",
          height: "4"
        }
      },
      lg: {
        root: {
          gap: "4"
        },
        control: {
          width: "11",
          p: "0.5"
        },
        thumb: {
          width: "5",
          height: "5"
        }
      }
    }
  }
});
export {
  a as switchRecipe
};
